<template>
  <el-dialog title="请配置投研助手功能" class="addDialog" :visible.sync="Visible" width="900px" :show-close="true"
             :close-on-press-escape="false" :close-on-click-modal="false">
    <div class="content-inner">
      <div class="l-inner">
        <div class="item">
          <div class="box" v-for="(item, index) in itemList" :key="'item-' + index">
            <div class="box-left">
              <p>功能{{ ZW[index] }}：</p>
            </div>
            <div class="box-center">
              <div class="box-line1">
                <p>功能案件名称</p>
                <el-input v-model="item.btnName" style="width: 3rem;"></el-input>
              </div>
              <div class="box-line2">
                <p>API秘钥</p>
                <div class="input-icon">
                  <el-input v-model="item.btnKey" style="width: 6rem;margin-right: 0.2rem;"></el-input>
                  <div class="icons">
                    <div class="el-icon-circle-plus"
                         style="font-size: 18px;color:#409eff; cursor: pointer;margin-right: 0.1rem;" @click="addItem">
                      新增</div>
                    <div class="el-icon-remove" style="font-size: 18px;color:#f56c6c;cursor: pointer;"
                         @click="removeItem(index)">删除</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="item">
          <p>（最多添加8个功能参数）</p>
        </div>
      </div>
    </div>
    <div class="footer-inner" slot="footer">
      <el-button type="primary" size="small" @click="handleSave">确 定</el-button>
      <el-button type="danger" size="small" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'creatDialog',
  props: {
    scenarioName () {
      return {
        type: String,
        default: ''
      }
    }
  },
  data () {
    return {
      Visible: false,
      ZW: ['一', '二', '三', '四', '五', '六', '七', '八'],
      itemList: [
        { id: 1, btnName: '', btnKey: '' },
      ]
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    let znty_save_list = JSON.parse(sessionStorage.getItem('znty_save_list'))
    if (znty_save_list) {
      this.itemList = znty_save_list
    } else {
      this.itemList = [
        { id: 1, btnName: '', btnKey: '' },
      ]
    }
  },
  mounted () {

  },
  methods: {
    // 跳转：
    show () {
      this.Visible = true
    },

    addItem () {
      if (this.itemList.length < 8) {
        this.itemList.push({ id: this.itemList.length + 1, btnName: '', btnKey: '' })
      } else {
        this.$message.warning('最多添加8个功能参数！')
        return
      }

    },
    removeItem (index) {
      if (index == 0) return
      this.itemList.splice(index, 1)
    },

    // 验证表单
    areSpecificPropsNonEmpty (arr, props) {
      return arr.every(obj => {
        return props.every(prop =>
          obj[prop] !== null &&
          obj[prop] !== undefined &&
          obj[prop] !== ''
        );
      });
    },

    //确定
    handleSave () {
      console.log("保存结果：", this.itemList);
      let hasEmpty = this.areSpecificPropsNonEmpty(this.itemList, ['btnName', 'btnKey'])
      if (!hasEmpty) {
        //有空值
        this.$message.warning('请完善功能配置表单内容！')
        return
      } else {
        //无空值
        sessionStorage.setItem('znty_save_list', JSON.stringify(this.itemList))
        this.$message.success('应用成功！')
        this.$emit('updateSetting')
        setTimeout(() => {
          this.Visible = false
        }, 800);
      }
    },

    //关闭
    handleClose () {
      this.Visible = false
    },

    handleUse () {
      let hasEmpty = this.areSpecificPropsNonEmpty(this.itemList, ['btnName', 'btnKey'])
      if (!hasEmpty) {
        //有空值
        this.$message.warning('请完善功能配置表单内容！')
        return
      } else {
        //无空值
        sessionStorage.setItem('znty_save_list', JSON.stringify(this.itemList))
        this.$message.success('应用成功！')
        setTimeout(() => {
          this.Visible = false
        }, 800);
      }
    },
  }
}
</script>

<style lang="less" scoped>
.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;
    overflow: auto;

    .label-inner {
      color: #333;
      margin-bottom: 12px;
      font-size: 15px;
      user-select: none;
    }

    .l-inner {
      // float: left;
      // width: 53%;
      // margin-right: 30px;
      width: 100%;
    }

    .item {
      margin-bottom: 30px;

      .box {
        display: flex;
        align-items: flex-start;

        .box-left {}

        .box-center {
          .box-line1 {}

          .box-line2 {
            .input-icon {
              display: flex;
              align-items: center;
            }
          }
        }

      }

    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}
</style>